import React, { useMemo } from "react";
import { Field } from "redux-form";
import { TextField } from "redux-form-material-ui";
import { isRequired, isNumericGtZero, isInteger } from "js/helpers/validations";
import { _t } from "js/utils/TranslationService";
import { intParser } from "js/pages/Admin/Programa/Edit/helper";
import { styles } from "../styles.js";
import { connect } from "react-redux";
import { touch } from "redux-form";

const InputIntegerField = ({
  name,
  label,
  placeholder,
  required,
  translation,
  classes,
  disabled,
  formName, // nombre del formulario Redux Form
  maxValue,
  touch
}) => {
  const maxValueValidation = useMemo(
    () => {
      if (maxValue == null) return undefined;
      return value => {
        if (value == null) return undefined;
        const num = Number(value);
        return isNaN(num) || num > maxValue
          ? `El valor debe ser menor o igual a ${maxValue}`
          : undefined;
      };
    },
    [maxValue]
  );

  const validations = useMemo(
    () => {
      const rules = [];
      if (required) rules.push(isRequired);
      rules.push(isNumericGtZero);
      rules.push(isInteger);
      if (maxValueValidation) rules.push(maxValueValidation);
      return rules;
    },
    [required, maxValueValidation]
  );

  const renderInput = ({ input, meta, ...rest }) => {
    const showError = Boolean(
      meta.error && (meta.touched || input.value !== "")
    );

    const handleChange = e => {
      const value = e.target.value;
      input.onChange(value);

      const numeric = Number(value);
      const invalid =
        value === "" ||
        isNaN(numeric) ||
        numeric <= 0 ||
        (maxValue != null && numeric > maxValue);

      if (!meta.touched && invalid && formName) {
        touch(formName, input.name);
      }
    };

    return (
      <TextField
        {...input}
        {...rest}
        onChange={handleChange}
        error={showError}
        helperText={showError ? meta.error : ""}
      />
    );
  };

  return (
    <Field
      type="text"
      required={required}
      name={name}
      label={translation || _t(label)}
      placeholder={placeholder}
      component={renderInput}
      disabled={disabled}
      fullWidth
      format={value => {
        return value ? parseInt(value, 10).toString() : "";
      }}
      normalize={value => {
        const onlyNums = String(value).replace(/[^\d]/g, "");
        return onlyNums === "" ? null : parseInt(onlyNums, 10);
      }}
      parse={intParser}
      validate={validations}
      InputLabelProps={{ shrink: true }}
      className={classes ? classes.field : styles.field}
    />
  );
};

export default connect(
  null,
  { touch }
)(InputIntegerField);
